<template>
	<div class="gallery-contain">
		<Header class="gallery-header" />
		<div class="gallery-main">
			<el-scrollbar class="gallery-main-scrollbar">
				<router-view :key="$route.path" />
			</el-scrollbar>
		</div>
		<RightHelp />
	</div>
</template>

<script>
import {mapMutations} from 'vuex'
import Header from '@/pages/Layout/Header'
import RightHelp from '@/pages/Layout/RightHelp'
export default {
	name: 'gallery',
	components: {
		Header
		, RightHelp
	},
	data () {
		return {}
	},
	created () {
	},
	methods: {
	}

}
</script>

<style lang="scss" scoped>
.gallery-contain {
	position: relative;
	height: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	background-color: #e8f1f9;
}
.gallery-header {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	z-index: 90;
	background-color: #fff;
}
.gallery-main {
	min-width: 1200px;
	padding: 146px 0 0;
	overflow-x: hidden;
	height: 100%;
}
</style>
